import React, { useCallback, useState } from 'react';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { IconMenuItem } from 'mui-nested-menu';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useVersionStore } from 'store/version.store';

import { useMutationDeleteCard } from 'api/mutations/deleteCard.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCardModal/components/SideMenu/SideMenu.module.scss';
import {
    CustomizedConfirmDeleteModal,
    CustomizedDropdownMenu,
    CustomizedRoundIcon,
    CustomizedTooltip,
} from 'components/common';

interface ISideMenuProps {
    title: string;
    id: number;
    handleModalClose: () => void;
    deleteCardCallback: () => void;
}

export const SideMenu = ({ title, id, handleModalClose, deleteCardCallback }: ISideMenuProps) => {
    const [deleteCardModalShow, setDeleteCardModalShow] = useState<boolean>(false);
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate: deleteCardMutate, isLoading: deleteCardLoading } = useMutationDeleteCard();
    const version = useVersionStore((state) => state.version);

    const handleCardDelete = useCallback(() => {
        setDeleteCardModalShow(false);
        if (id && version) {
            deleteCardMutate(
                { cardId: id, versionId: version.id },
                {
                    onSuccess: () => {
                        handleSnackBar('Card Deleted Successfully', 'success');
                        handleModalClose();
                        deleteCardCallback();
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    }, []);

    return (
        <div className={classes.sideMenuContainer}>
            <ShareInsightButton title={`activity "${title}"`} link={window.location.href.split('?')[0]} size={'30px'} />

            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipContent={`Manage Activity`}
                        triggerElement={
                            <CustomizedRoundIcon size={'30px'}>
                                <Icon name={'three-dot-icon'} />
                            </CustomizedRoundIcon>
                        }
                    />
                }
            >
                <MenuItem
                    onClick={() => {
                        setDeleteCardModalShow(true);
                    }}
                >
                    <ListItemIcon>
                        <MuiIcon icon={'delete'} type={'outlined'} />
                    </ListItemIcon>
                    Delete
                </MenuItem>
            </CustomizedDropdownMenu>

            <CustomizedConfirmDeleteModal
                isShowModal={deleteCardModalShow}
                hideModal={() => {
                    setDeleteCardModalShow(false);
                }}
                text={'Are you sure you want to delete this Card?'}
                onConfirm={handleCardDelete}
                isLoading={deleteCardLoading}
            />
        </div>
    );
};
